var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C8.09625 2.5 2.5 8.09625 2.5 15C2.5 21.9037 8.09625 27.5 15 27.5C21.9037 27.5 27.5 21.9037 27.5 15C27.5 8.09625 21.9037 2.5 15 2.5Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M18.75 21.875V16.25C18.75 15.5606 18.1894 15 17.5 15C16.8106 15 16.25 15.5606 16.25 16.25V21.875H12.5V11.25H16.25V11.8919C16.9 11.4744 17.6575 11.25 18.4375 11.25C20.6775 11.25 22.5 13.0725 22.5 15.3125V21.875H18.75ZM8.125 21.875V11.25H9.97875C8.90437 11.25 8.125 10.4612 8.125 9.37437C8.125 8.28812 8.91687 7.5 10.0069 7.5C11.0669 7.5 11.8525 8.2825 11.875 9.36187C11.875 10.4581 11.0831 11.25 9.9925 11.25H11.875V21.875H8.125Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M19.0625 21.5625V16.25C19.0625 15.3888 18.3619 14.6875 17.5 14.6875C16.6381 14.6875 15.9375 15.3888 15.9375 16.25V21.5625H12.8125V11.5625H15.9375V12.5213C16.6187 11.9106 17.5075 11.5625 18.4375 11.5625C20.5056 11.5625 22.1875 13.2444 22.1875 15.3125V21.5625H19.0625ZM8.4375 21.5625V11.5625H11.5625V21.5625H8.4375ZM9.97875 10.9375C9.08562 10.9375 8.4375 10.28 8.4375 9.37437C8.4375 8.46937 9.0975 7.8125 10.0069 7.8125C10.9044 7.8125 11.5438 8.45188 11.5625 9.36813C11.5625 10.28 10.9019 10.9375 9.9925 10.9375H9.97875Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.875H11.25V21.25H8.75V11.875ZM9.9925 10.625H9.97875C9.2325 10.625 8.75 10.0687 8.75 9.37437C8.75 8.665 9.2475 8.125 10.0069 8.125C10.7675 8.125 11.2356 8.665 11.25 9.37437C11.25 10.0687 10.7675 10.625 9.9925 10.625ZM21.875 15.3125C21.875 13.4137 20.3363 11.875 18.4375 11.875C17.2738 11.875 16.2469 12.455 15.625 13.34V11.875H13.125V21.25H15.625V16.25C15.625 15.2144 16.4644 14.375 17.5 14.375C18.5356 14.375 19.375 15.2144 19.375 16.25V21.25H21.875C21.875 21.25 21.875 15.5756 21.875 15.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b04039caab9c65aa73bb17013953627e.svg";
export { ForwardRef as ReactComponent };